<template>
    <div>
        <div v-if="str" class="app-container">
            <div v-if="hasData === true" class="app-title">
                {{ subType ? (str[subType.label] ? str[subType.label] : subType.label) : (type ? (str[type.label] ? str[type.label] : type.label) : str['contents']) }}
            </div>
            <div
                v-if="hasData === true && filter && types && types.length"
                class="select-filter"
            >
                <v-select
                    v-model="filterActive"
                    item-text="label"
                    item-value="value"
                    :items="types"
                    :no-data-text="str['no_data']"
                    hide-details
                    outline
                    append-icon="fa-caret-down"
                />
            </div>
            <div v-if="hasData === true" class="app-cards">
                <div v-for="item in filteredData" :key="item.id">
                    <v-card class="cursor-hover" @click="openItem(item)">
                        <v-img
                            :src="item.image"
                            class="align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            height="200px"
                            cover
                        >
                            <v-card-title>
                                <div>
                                    {{ item.name }}
                                </div>
                                <img
                                    v-if="alerts && alerts.indexOf(item.id) > -1"
                                    src="../assets/images/icon_new.svg"
                                    class="app-cards-float-icon"
                                />
                            </v-card-title>
                        </v-img>
                    </v-card>
                </div>
            </div>
            <div v-if="hasData === false || (hasData === true && !filteredData.length)" class="app-error-info">
                <img src="../assets/images/icon_no_data.svg" />
                <div>
                    {{ str['contents_empty'] }}
                </div>
            </div>
            <div v-if="hasData !== null && (type || subType)" class="app-footer flex-center">
                <v-btn @click="back()" class="default">
                    {{ str['back'] }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import Api from '../services/Api'
import Utils from '../services/Utils'

export default {
    data() {
        const type = this.$route.query && this.$route.query.type_label ? {
            label: this.$route.query.type_label,
            value: parseInt(this.$route.query.type_value),
        } : null
        const subType = this.$route.query && this.$route.query.sub_type_label ? {
            label: this.$route.query.sub_type_label,
            value: parseInt(this.$route.query.sub_type_value),
        } : null
        const filter = this.$route.query && this.$route.query.filter ? this.$route.query.filter : null
        const types = filter ? Utils.getContentTypes() : null
        return {
            str: Utils.getStrings(),
            type: type,
            subType: subType,
            filter: filter,
            types: types,
            filterActive: window.cache && window.cache.filterActive ? window.cache.filterActive : (types && types[0] ? types[0].value : null),
            data: [],
            hasData: null,
            alerts: window.appCache && window.appCache.alertsNewContents ? window.appCache.alertsNewContents.map(a => a.id) : null,
        }
    },
    beforeMount: function () {
        this.main()
    },
    computed: {
        filteredData() {
            const self = this
            if (this.filter && this.filterActive !== null) {
                return this.data.filter(function (item) {
                    return item.type === self.filterActive
                })
            }
            return this.data
        }
    },
    methods: {
        main: function () {
            this.$isLoading(true)
            Utils.refreshAppUrl()
            if (window.cache && window.cache.contents) {
                this.data = window.cache.contents
                this.hasData = window.cache.hasContents
                this.$isLoading(false)
            } else {
                this.getContents()
            }
        },
        getContents: function () {
            const self = this
            Api.getContents({
                type: this.type ? this.type.value : null,
                sub_type: this.subType ? this.subType.value : null,
            },function (response) {
                self.$isLoading(false)
                if (response.success) {
                    const items = []
                    const keyLng =  '_' + window.language
                    response.data.forEach(function (item) {
                        items.push({
                            id: item.id,
                            type: item.type,
                            sub_type: item.sub_type,
                            name: item['name' + keyLng] ? item['name' + keyLng] : item.name,
                            info: item['description' + keyLng] ? item['description' + keyLng] : item.description,
                            image: item.image,
                            urls: self.getItemUrls(item),
                        })
                    })
                    self.data = items
                    self.hasData = self.data.length ? true : false
                    window.cache = {
                        contents: self.data,
                        hasContents: self.hasData
                    }
                } else {
                    self.$alert(
                        response.message,
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                }
            })
        },
        getItemUrls: function (item) {
            try {
                const urls = JSON.parse(item.url);
                for (let i = 0; i < urls.length; i++) {
                    urls[i] = this.isYoutubeUrl(urls[i]) ? Utils.getYoutubeEmbedUrl(urls[i]) : urls[i]
                }
                return urls ? urls : [];
            } catch (error) {
                if (item.url) {
                    return [this.isYoutubeUrl(item.url) ? Utils.getYoutubeEmbedUrl(item.url) : item.url];
                } else {
                    return [];
                }
            }
        },
        openItem: function (item) {
            const url = item.urls.length == 1 ? item.urls[0] : null;
            if (this.isYoutubeUrl(url)) {
                window.cache = window.cache ? window.cache : {}
                window.cache.content = item
                window.cache.filterActive = this.filterActive
                this.$router.push({ path: '/content' })
            } else {
                if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({
                        event: 'link',
                        data: url
                    }))
                }
            }
        },
        isYoutubeUrl: function (url) {
            if (url && typeof url === 'string' && url.indexOf('youtube.com') === -1 && url.indexOf('youtu.') === -1) {
                return false
            }
            return true
        },
        back: function () {
            if (this.type || this.subType) {
                this.$router.back()
            } else {
                if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({
                        event: 'close'
                    }))
                }
            }
        },
        onBackEvent: function () {
            const self = this
            this.$root.$on('app-back', function () {
                self.back()
            })
        },
        offBackEvent: function () {
            this.$root.$off('app-back')
        },
    },
    mounted () {
        this.onBackEvent()
    },
    beforeDestroy () {
      this.offBackEvent()
    }
}
</script>